module.exports = __webpack_public_path__ + "img/011.688de91e.jpg";